export default "__VITE_PUBLIC_ASSET__23c35c92__"